import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Fund } from 'src/app/domain/fund-performance/dto/Fund';
import dayjs from 'dayjs';
import { ModalButtons } from 'src/app/domain/shared/component/modal-container/modal-container.component';

@Component({
  selector: 'app-modal-fund-term',
  templateUrl: './modal-fund-term.component.html',
  styleUrls: ['./modal-fund-term.component.scss'],
})
export class ModalFundTermComponent implements OnInit {

  @Output() closeModal = new EventEmitter();
  @Output() confirm = new EventEmitter<string>();

  @Input() fund: Fund;
  @Input() countedPeriodType: BaseFundDateType;

  addedMonths = 0; // months to add if base type is switched
  addedYears = 0; // years to add if base type is switched
  addedDays = 0; // days to add if base type is switched

  modalButtons: ModalButtons = {
    dismiss: 'Dismiss',
    apply: 'Apply',
  };

  baseType = 'Initial closing';
  selectorData = ['Initial closing', 'Final closing'];
  countedPeriod: string;

  ngOnInit(): void {
    if (this.countedPeriodType === 'Fund term') {
      this.selectorData.push('Investment period');
    }
  }

  chooseTypeFrom(type: BaseFundDateType): void {
    this.baseType = type;
    this.addMonths();
  }

  addMonths(): void {
    if (!this.addedMonths && !this.addedYears && !this.addedDays) {
      this.countedPeriod = null;
      return;
    }
    const totalMonths = this.addedYears ? Number(this.addedYears) * 12 + Number(this.addedMonths) : this.addedMonths;
    if (this.baseType === 'Initial closing') {
      this.countedPeriod = dayjs(this.fund.initialClosing).add(totalMonths, 'month').format('YYYY-MM-DD');
    } else if (this.baseType === 'Final closing') {
      this.countedPeriod = dayjs(this.fund.finalClosing).add(totalMonths, 'month').format('YYYY-MM-DD');
    } else if (this.baseType === 'Investment period') {
      this.countedPeriod = dayjs(this.fund.investmentPeriod).add(totalMonths, 'month').format('YYYY-MM-DD');
    }
  }

  addDays(): void {
    if (!this.addedMonths && !this.addedYears && !this.addedDays) {
      this.countedPeriod = null;
      return;
    }
    this.addMonths();
    this.countedPeriod = dayjs(this.countedPeriod).add(this.addedDays, 'day').format('YYYY-MM-DD');
  }
}

export type BaseFundDateType = 'Initial closing' | 'Final closing' | 'Investment period' | 'Fund term';
